import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { UserProvider } from "./context/UserContext.js";
import { TicketProvider } from "./context/TicketContext";
import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "./Approutes.jsx"; 

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <UserProvider>
          <TicketProvider>
            <Router>
              <AppRoutes />
            </Router>
          </TicketProvider>
        </UserProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
